import { apiPost } from './client'

export interface AutotuneCandidate {
  overrides: Record<string, number | string | boolean>
  label: string
  metrics: {
    total_return_pct: number | null
    max_drawdown_pct: number | null
    sharpe_daily_252: number | null
    win_rate_pct: number | null
    trades: number | null
  }
  run_id: string | null
}

export interface AutotuneTopCandidate extends AutotuneCandidate {
  proposed_revision: Record<string, unknown>
  balanced_score: number
  reason: string
}

export interface AutotuneResponse {
  plan_id: string
  plan_version_id: string
  strategy_kind: string
  start: string
  end: string
  candidate_count: number
  frontier_count: number
  top: AutotuneTopCandidate[]
  all_candidates: AutotuneCandidate[]
  error?: string
}

export interface AutotuneRequest {
  start: string  // ISO date
  end: string
  initial_capital?: number
  max_iterations?: number
  top_n?: number
}

export const runAutotune = (planId: string, req: AutotuneRequest) =>
  apiPost<AutotuneResponse>(`/plans/${planId}/autotune`, req)

export interface ApplyRevisionRequest {
  revised_plan: Record<string, unknown>
  reason: string
}

export interface ApplyRevisionResponse {
  plan_id: string
  version: number
  version_id: string
  lifecycle: string
  coverage: Record<string, unknown> | null
  revised_from_version: number
}

export const applyRevision = (planId: string, req: ApplyRevisionRequest) =>
  apiPost<ApplyRevisionResponse>(`/plans/${planId}/revise`, req)
